export const sendMetrik = (type, value) => {
    window.ym(88000264, type, value);
}